export default __webpack_public_path__ + "static/media/userjourney1.bf7cba83.png";